/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { CroBridge, CroBridgeInterface } from "../CroBridge";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "recipient",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "__CronosSendCroToIbc",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "recipient",
        type: "string",
      },
    ],
    name: "send_cro_to_crypto_org",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b506101bb806100206000396000f3fe60806040526004361061001e5760003560e01c8063c41cc27014610023575b600080fd5b6100dc6004803603602081101561003957600080fd5b810190808035906020019064010000000081111561005657600080fd5b82018360208201111561006857600080fd5b8035906020019184600183028401116401000000008311171561008a57600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f8201169050808301925050505050505091929192905050506100de565b005b7f7e9f07720f59ca7f223af10cdb92871767959977aa377c9ce957c1bcda0188a581346040518080602001838152602001828103825284818151815260200191508051906020019080838360005b8381101561014757808201518184015260208101905061012c565b50505050905090810190601f1680156101745780820380516001836020036101000a031916815260200191505b50935050505060405180910390a15056fea264697066735822122081ca6622a2d9481e6045365520c6e961f24f6b2bd93872d3994866c7e24f35f064736f6c63430006060033";

export class CroBridge__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CroBridge> {
    return super.deploy(overrides || {}) as Promise<CroBridge>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): CroBridge {
    return super.attach(address) as CroBridge;
  }
  connect(signer: Signer): CroBridge__factory {
    return super.connect(signer) as CroBridge__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CroBridgeInterface {
    return new utils.Interface(_abi) as CroBridgeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CroBridge {
    return new Contract(address, _abi, signerOrProvider) as CroBridge;
  }
}
